module.exports = __webpack_public_path__ + "img/telegram_background.c4bf6d06.jpg";